import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { RootState } from '../../reducers'
import { Autocomplete, TextField, Typography } from '@mui/material'
import { UserBannerPathologist, UserBannerProps } from '../../interfaces/calendar'
import { fetchUsersData } from '../../actions'

export const UserBanner = ({ updateUserView, userInfo }: UserBannerProps): JSX.Element => {
  const dispatch = useDispatch()
  const getUsers = useSelector((state: RootState) => state.getUsers)
  const pathologists = getUsers?.data
  let activePathologists = []

  if (pathologists) {
    const filterUserResults = pathologists.filter((value) => {
      if (value.user_roles) {
        return value.user_roles == 'NL_Pathologist' && value.user_status === true
      }
    })
    activePathologists = filterUserResults.map((user) => {
      return { user_name: `${user.first_name}, ${user.last_name}`, user_id: Number(`${user.user_id}`) }
    })
  }

  useEffect(() => {
    dispatch(fetchUsersData())
  }, [dispatch])

  function handleSelect(event, value) {
    if (updateUserView) {
      updateUserView(event, value)
    }
  }

  return (
    <div className="WP_Search" style={{ width: '100%' }}>
      <Typography variant="subtitle1" style={{ color: 'white', marginLeft: '30px', marginRight: '10px' }}>
        Currently viewing:
      </Typography>
      <div className="WP_select">
        <Autocomplete
          disablePortal
          value={userInfo}
          id="combo-box-demo"
          options={activePathologists}
          getOptionLabel={(option: UserBannerPathologist) => option?.user_name}
          onChange={(event, value) => handleSelect(event, value)}
          style={{ width: 300, backgroundColor: 'white' }}
          renderInput={(params) => <TextField {...params} label="All Users" variant="outlined" size="small" />}
        />
      </div>
    </div>
  )
}
